module.exports = __webpack_public_path__ + "assets/img/dzh-5.4606392a.jpg";